import React, { useEffect, useState } from "react";
import { IMaskInput } from "react-imask";
import { getTranslatedTextIfNeeded } from "../../../../../shared/InternationalizationTextUtils";
import "./TextQuestionComponent.scss";

function TextQuestionComponent({ question, answer, onAnswer, selectedTopic, isLiteSurvey }) {
    const [isMounted, setIsMounted] = useState(false);
    const [value, setValue] = useState(answer.userAnswer || "");

    const hasMask = Boolean(answer.inputMask && answer.inputMask.mask);
    const effectiveMaxLength = !hasMask && Number.isInteger(answer.maxLength) && answer.maxLength > 0 ? answer.maxLength : null;

    const handleInputChange = (event) => {
        let inputValue = event.target.value;
        if (effectiveMaxLength !== null && inputValue.length > effectiveMaxLength) {
            inputValue = inputValue.slice(0, effectiveMaxLength);
        }
        if (isLiteSurvey && isMounted) {
            inputValue = question.text.toLowerCase()?.includes("email") ? inputValue : inputValue.replace(/[^A-Za-z\s'-]/g, "");
            answer.userAnswer = inputValue;
            onAnswer(selectedTopic, question, answer);
        }

        setValue(inputValue.trimStart());
    };

    useEffect(() => {
        if (!isLiteSurvey && isMounted) {
            const timer = setTimeout(() => {
                if (value !== answer.userAnswer) {
                    answer.userAnswer = value;
                    onAnswer(selectedTopic, question, answer);
                }
            }, 400);
            return () => clearTimeout(timer);
        }
        setIsMounted(true);
    }, [value]);

    const inputId = `masked-${answer.sequenceId}`;
    if (answer.inputMask && answer.inputMask.mask) {
        return (
            <div key={inputId}>
                <p className="masked-input-label">{getTranslatedTextIfNeeded(answer.text)}</p>
                <IMaskInput
                    id={inputId}
                    mask={answer.inputMask.mask}
                    lazy={false}
                    value={value}
                    type="text"
                    className="masked"
                    placeholderChar="_"
                    onAccept={(value) => handleInputChange({ target: { value } })}
                />
            </div>
        );
    } else {
        return (
            <>
                <input
                    id={getTranslatedTextIfNeeded(question.text)}
                    key={inputId}
                    type="text"
                    placeholder={getTranslatedTextIfNeeded(answer.text)}
                    value={value}
                    maxLength={effectiveMaxLength ?? undefined}
                    onChange={(event) => handleInputChange(event)}
                    data-testid="text-question-input"
                />
                {effectiveMaxLength !== null && (
                    <div
                        className={`text-question-counter ${value.length >= effectiveMaxLength ? "at-limit" : ""}`}
                        data-testid="text-question-counter"
                        aria-live="polite"
                    >
                        {`${value.length}/${effectiveMaxLength}`}
                    </div>
                )}
            </>
        );
    }
}

export default TextQuestionComponent;
